import { useEffect, RefObject } from 'react';

let scrollLockCount = 0;
let lastScrollY = 0;
const modalScrollPositions = new Map<HTMLElement, number>();
const modalContainerStyles = new Map<
  HTMLElement,
  {
    position: string;
    top: string;
    width: string;
    overflow: string;
    touchAction: string;
  }
>();

export const useScrollLock = (
  active: boolean,
  containerRef?: RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    if (active) {
      if (scrollLockCount > 0) {
        const modalContainers = document.querySelectorAll('.modal-opened');
        const container = modalContainers[scrollLockCount - 1] as
          | HTMLElement
          | undefined;

        if (container) {
          const scrollTop = container.scrollTop;
          modalScrollPositions.set(container, scrollTop);

          modalContainerStyles.set(container, {
            position: container.style.position || '',
            top: container.style.top || '',
            width: container.style.width || '',
            overflow: container.style.overflow || '',
            touchAction: container.style.touchAction || '',
          });

          container.style.position = 'fixed';
          container.style.width = '100%';
          container.style.touchAction = 'none';
        }
      }

      if (scrollLockCount === 0) {
        lastScrollY = window.scrollY;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${lastScrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflowY = 'scroll';
        document.body.style.touchAction = 'none';
        document.body.classList.add('modal-scroll-locked');
      }

      scrollLockCount += 1;
    }

    return () => {
      if (active) {
        scrollLockCount = Math.max(scrollLockCount - 1, 0);

        if (scrollLockCount > 0) {
          const modalContainers = document.querySelectorAll('.modal-opened');
          const container = modalContainers[scrollLockCount - 1] as
            | HTMLElement
            | undefined;

          if (container) {
            const savedScrollTop = modalScrollPositions.get(container);
            const savedStyles = modalContainerStyles.get(container);

            if (savedScrollTop !== undefined && savedStyles) {
              if (container && container.isConnected) {
                container.style.position = savedStyles.position;
                container.style.top = savedStyles.top;
                container.style.width = savedStyles.width;
                container.style.overflow = savedStyles.overflow;
                container.style.touchAction = savedStyles.touchAction;

                container.scrollTop = savedScrollTop;
                container.scrollTo(0, savedScrollTop);

                modalScrollPositions.delete(container);
                modalContainerStyles.delete(container);
              }
            }
          }
        }

        if (scrollLockCount === 0) {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflowY = '';
          document.body.style.touchAction = '';
          document.body.classList.remove('modal-scroll-locked');

          window.scrollTo(0, lastScrollY);
        }
      }
    };
  }, [active, containerRef]);
};
